import Checkbox from './Checkbox'
Vue.component(Checkbox.name, Checkbox)

import FormGroupRow from './FormGroupRow'
Vue.component(FormGroupRow.name, FormGroupRow)

import FormInput from './FormInput'
Vue.component(FormInput.name, FormInput)

import ReValidation from './re-validation'
Vue.component(ReValidation.name, ReValidation)

import ValidationInput from './re-validation-input'
Vue.component(ValidationInput.name, ValidationInput)

import ReInput from './re-input'
Vue.component(ReInput.name, ReInput)

import ReMaskInput from './re-mask-input'
Vue.component(ReMaskInput.name, ReMaskInput)

import ReCheckbox from './re-checkbox'
Vue.component(ReCheckbox.name, ReCheckbox)

import ReCheckboxes from './re-checkboxes'
Vue.component(ReCheckboxes.name, ReCheckboxes)

import ReRadio from './re-radio'
Vue.component(ReRadio.name, ReRadio)

import ReRadios from './re-radios'
Vue.component(ReRadios.name, ReRadios)

import ReDatePicker from './re-date-picker'
Vue.component(ReDatePicker.name, ReDatePicker)

import ReDateInputs from './re-date-inputs'
Vue.component(ReDateInputs.name, ReDateInputs)

import ReSelect from './re-select'
Vue.component(ReSelect.name, ReSelect)

import ReTextarea from './re-textarea'
Vue.component(ReTextarea.name, ReTextarea)

import ReAgreeToTerms from './re-agree-to-terms'
Vue.component(ReAgreeToTerms.name, ReAgreeToTerms)

import ReForm from './re-form'
Vue.component(ReForm.name, ReForm)

export default {
  Checkbox,
  FormGroupRow,
  FormInput,
  ReValidation,
  ValidationInput,

  ReInput,
  ReMaskInput,
  ReCheckbox,
  ReCheckboxes,
  ReRadio,
  ReRadios,
  ReDatePicker,
  ReDateInputs,
  ReSelect,
  ReTextarea,
  ReAgreeToTerms,
  ReForm,
}
